import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "@/components/navigation/NavBar";
import Footer from "@/components/navigation/Footer";
import { sanityApi } from "@/features/sanity";
import {
  Autocomplete,
  TextField,
  Button,
  Box,
  MenuItem,
  InputAdornment,
} from "@mui/material";
// REMOVED: import { fetchFilteredPosts } from '@/lib/sanity';
// REMOVED: import { fetchCategories } from '@/lib/sanity';
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { FilterIcon } from "@/components/icons/legacy-svgs";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [sortBy, setSortBy] = useState("publishedAt");
  const navigate = useNavigate(); // React Router v6 navigation hook
  const [categories, setCategories] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  // Fetch categories dynamically
  useEffect(() => {
    async function loadCategories() {
      const data = await sanityApi.fetchCategories();
      setCategories(data);
    }
    loadCategories();
  }, []);

  const handleSearchChange = (value) => {
    setSearch(value);
    // onSearch({ search: value, category, dateRange, sortBy }); // Removed onSearch if it wasn't defined in snippet
  };
  useEffect(() => {
    async function loadPosts() {
      const data = await sanityApi.fetchFilteredPosts({
        search,
        category,
        dateRange,
        sortBy,
      });
      setPosts(data);
    }
    loadPosts();
  }, [search, category, dateRange, sortBy]);

  const handlePostClick = (slug) => {
    navigate(`/ratgeber/${slug}`); // Programmatic navigation
  };
  const groupedPosts = posts.reduce((acc, post) => {
    acc[post.category] = acc[post.category] || [];
    acc[post.category].push(post);
    return acc;
  }, {});

  return (
    <div>
      <NavBar className="relative" />
      <div className="relative w-full ">
        <img
          className="max-h-[40vh] w-full object-cover object-center"
          src="/Fotos/ratgeber-hero.jpg"
          alt=""
        />
        <div className="absolute bottom-2 left-2 py-1 px-3 bg-prime-950 shadow-inner flex items-center justify-center rounded-sm">
          <h1 className="text-3xl font-semibold text-white ">
            Immobilien Ratgeber
          </h1>
        </div>
      </div>
      <div className="container max-w-6xl mx-auto p-6">
        <div>
          {/* Filters */}
          <Box sx={{ width: "70%", paddingBottom: "3rem" }}>
            {/* Search Input */}
            <Autocomplete
              freeSolo
              options={posts.map((cat) => cat.title)}
              value={search}
              onChange={(e, value) => handleSearchChange(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Geben Sie einen Begriff ein"
                  size="small"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <MagnifyingGlassIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                  label="Suchen"
                  variant="outlined"
                  fullWidth
                />
              )}
            />

            {/* Expand/Collapse Toggle */}
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setIsExpanded(!isExpanded)}
              sx={{
                maxWidth: "200px",
                mt: 1,
                color: "#32579b",
                borderColor: "#32579b",
                display: "flex",
                justifyItems: "around",
              }}
            >
              <FilterIcon />
              {isExpanded ? "Weniger Filter" : "Weitere Filter"}
            </Button>

            {/* Filters Dropdown */}
            {isExpanded && (
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              >
                {/* Category Filter */}
                <TextField
                  select
                  label="Kategorie"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  fullWidth
                  variant="outlined"
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="">Alle Kategorien</MenuItem>
                  {categories.map((cat) => (
                    <MenuItem key={cat._id} value={cat.name}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Date Range Filter */}
                <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                  <div className="flex gap-4 mb-4 ">
                    <input
                      type="date"
                      onChange={(e) =>
                        setDateRange([e.target.value, dateRange[1]])
                      }
                      className="p-2 border rounded bg-white w-full"
                    />
                    <input
                      type="date"
                      onChange={(e) =>
                        setDateRange([dateRange[0], e.target.value])
                      }
                      className="p-2 border rounded bg-white w-full"
                    />
                  </div>
                </Box>

                {/* Sort By Filter */}
                <TextField
                  select
                  label="Sortieren nach"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  fullWidth
                  variant="outlined"
                >
                  <MenuItem value="publishedAt">Datum</MenuItem>
                  <MenuItem value="category">Kategorie</MenuItem>
                  <MenuItem value="title">Titel</MenuItem>
                </TextField>
              </Box>
            )}
          </Box>
        </div>
        <div className="py-5">
          {Object.entries(groupedPosts).map(([category, posts]) => {
            const categoryDetails = categories.find(
              (cat) => cat.name === category
            );

            return (
              <div className="mb-10" key={category}>
                <hr className="pb-2 fill-prime-900" />
                {/* {categoryDetails && (
          <>
            <img
              className='w-full max-h-40 object-cover brightness-75 rounded-md mb-4'
              src={categoryDetails.imageUrl}
              alt={categoryDetails.name}
            />
          </>
        )} */}
                <h2 className="text-2xl uppercase font-semibold text-prime-900">
                  {category}
                </h2>
                <p className="text-gray-600 text-sm  mb-4">
                  {categoryDetails.description}
                </p>
                <hr className="pt-2 fill-prime-900" />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                  {posts.map((post) => (
                    <div
                      key={post._id}
                      className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer"
                      onClick={() => handlePostClick(post.slug.current)}
                    >
                      <img
                        src={post.mainImageUrl}
                        alt={post.mainImage?.alt || "Post Image"}
                        className="w-full h-60 object-cover"
                      />
                      <div className="p-6">
                        <p
                          onClick={() => navigate(`/ratgeber`)}
                          className="text-[#e95c0c] cursor-pointer pb-2 transition-all hover:text-prime-800 w-fit"
                        >
                          {post.category}
                        </p>
                        <h2 className="text-2xl font-semibold">{post.title}</h2>
                        <p className="text-sm text-gray-400 mt-2">
                          {new Date(post.publishedAt).toLocaleDateString(
                            "de-DE"
                          )}
                        </p>
                        <p className="text-gray-600 mt-2">von {post.author}</p>
                        <p className="mt-4 block text-blue-600 hover:underline">
                          Weiterlesen
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}
